/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BankAccount/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Checkbox from 'DesignSystem/Checkbox/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function BankAccount({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/TreatmentRequestOverride/Content/Downpayment/BankAccount"
  
}) {
let rulesetDownpaymentPaymentMethodsValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'downpayment_payment_methods',
})
let constantData = 'bank_account'
let aggregateData = fromAggregate.includes(rulesetDownpaymentPaymentMethodsValueData, constantData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
 data="ruleset.downpayment_payment_methods"
 data="'bank_account'"
 aggregate="/Data/aggregate.js includes"
 isSelected={aggregateData}
 onClick={onClick}
 marginLeft={dtSpaceXxs}
 text="BANK ACCOUNT"
/>
{children}
</React.Fragment>)
}